<template>
    <div class="container">
        <van-nav-bar title="修改密码" left-text="返回" left-arrow @click-left="$router.go(-1)" />
        <div class="step0" v-if="user && step==0">
            <div class="cell-group">
                <van-cell-group title="第一步：验证手机号">
                    <van-field label="手机号码" :value="user.mobile | mask('phone')" readonly />
                    <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入短信验证码">
                        <template #button>
                            <van-button size="small" type="info" @click="sendCode()" v-if="!isSending">发送验证码
                            </van-button>
                            <van-button size="small" type="info" :disabled="true" v-else>已发送（{{countDown}}）</van-button>
                        </template>
                    </van-field>
                </van-cell-group>
            </div>
            <div class="cell-group" style="margin-top:40px">
                <van-button size="large" type="default" plain @click="nextStep()">下一步</van-button>
            </div>
        </div>
        <transition name="van-slide-right">
            <div class="step1" v-if="user&&step==1">
                <van-cell-group title="第二步：设置新密码">
                    <van-field v-model="password1" type="password" label="新的密码"
                        :placeholder="passwordSetting.passwordTips" />
                    <van-field v-model="password2" type="password" label="确认密码" placeholder="重复输入确认密码" />
                </van-cell-group>
                <div class="cell-group" style="margin-top:40px">
                    <van-button size="large" type="info" @click="updatePassword()">更新密码</van-button>
                </div>
            </div>
        </transition>

        <div class="captcha-wrap">
            <van-overlay :show="captchaDialogVisible">
                <captcha-dialog v-if="captchaDialogVisible" @change="sendSmsCodeWithCaptcha"
                    @cancel="captchaDialogVisible=false" />
            </van-overlay>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .container {
        height: 100%;
    }

    .step0 {
        padding: 12px;
    }

    .step1 {
        padding: 12px;
    }

    .cell-group {
        margin-top: 12px;

    }
</style>

<script>
    import {
        mapState
    } from "vuex";
    import * as auth from "@/libs/auth";
    import * as user_api from "@/api/user"
    import * as valid_util from '@/libs/validate-utils'
    import footerTabbar from "../components/footerTabbar.vue";
    import CaptchaDialog from '../../components/captchaDialog.vue';
    export default {
        data() {
            return {
                name: "",
                step: 0,
                user: null,
                sms: "",
                userState: {
                    reportCount: 0,
                    orderCount: 0
                },
                password1: "",
                password2: "",
                passwordSetting: {
                    securityLevel: 0,
                    passwordTips: '长度8位或以上'
                },
                isSending: false,
                countDown: 30,
                timer: undefined,
                captchaDialogVisible: false, //显示图片验证码窗口
                sign: "", //用于提交更改密码时的签名
            }
        },
        computed: {
            ...mapState({
                configs: state => state.hospital.configs
            }),
            //是否启用图形验证码
            enableCaptcha() {
                if (this.configs && this.configs.length > 0) {
                    var cfg = this.configs.find(it => it.code == 'enable_captcha');
                    if (cfg && cfg.value == '是')
                        return true;
                }
                return false;
            },
        },
        components: {
            footerTabbar,
            CaptchaDialog
        },
        mounted() {
            let userInfo = auth.getUser();
            if (userInfo) {
                this.name = userInfo.name;
                this.user = userInfo;
            } else {
                return;
            }
            user_api.getUserState().then(res => {
                if (res.code == 200) {
                    this.userState = res.data;
                } else {
                    this.userState = {
                        reportCount: 0,
                        orderCount: 0
                    }
                }
            })

            //获取密码等级配置
            if (this.configs && this.configs.length) {
                var config = this.configs.find(it => {
                    return it.code == "user_password_level"
                });
                if (config && config.value) {
                    this.passwordSetting = {
                        securityLevel: parseInt(config.value),
                        passwordTips: config.detail_note
                    }
                }
            }
        },

        methods: {
            sendCode() {
                let _this = this;
                let hospId = this.$route.query.hospid;
                if (this.enableCaptcha) {
                    this.captchaDialogVisible = true;
                    return;
                }
                user_api.sendSmsCode(hospId, this.user.mobile).then(resp => {
                    if (resp.code != 200) {
                        this.$toast.fail("获取短信验证码出错！");
                    } else {
                        if (process.env.NODE_ENV !== 'production') {
                            _this.sms = resp.data;
                        }
                    }
                })

                this.isSending = true;
                this.countDown = 30;
                if (!this.timer) {
                    let _this = this;
                    this.timer = setInterval(() => {
                        if (_this.countDown <= 0) {
                            _this.isSending = false;
                        } else {
                            _this.countDown--;
                        }
                    }, 1000);
                }
            },
            //发送短信验证码（需要进行图片验证）
            sendSmsCodeWithCaptcha(captcha) {
                let _this = this;
                let hospId = this.$route.query.hospid;
                _this.captchaDialogVisible = false;
                user_api.sendSmsVerificationCode(hospId, this.user.mobile, captcha.key, captcha.value).then(res => {
                    if (res.code != 200) {
                        _this.$Toast.fail(res.msg, 5000);
                    } else {
                        // 已发送，待用户输入短信码
                        _this.isSending = true;
                        _this.countDown = 90;
                        if (!_this.timer) {
                            _this.timer = setInterval(() => {
                                if (_this.countDown <= 0) {
                                    _this.isSending = false;
                                } else {
                                    _this.countDown--;
                                }
                            }, 1000);
                        }
                    }
                })
            },
            nextStep() {
                if (!this.sms || this.sms == "") {
                    this.$toast("请输入验证码");
                    return;
                } else {
                    user_api.checkSmsCode(this.user.mobile, this.sms).then(res => {
                        if (res.code == 200) {
                            this.sign = res.data; //保存签名
                            this.step = 1;
                        } else {
                            this.$toast(res.msg);
                        }
                    })
                }
            },
            updatePassword() {
                if (this.password1 == "" || this.password1.length < 8) {
                    this.$Toast("密码长度需要设置为8位或以上");
                    return false;
                } else if (this.password1 !== this.password2) {
                    this.$Toast("密码输入不一致")
                    return false;
                }
                let pwdResult = valid_util.isStrongPassword(this.password1, this.passwordSetting.securityLevel);
                if (!pwdResult.result) {
                    this.$Toast("密码不符合安全等级要求：" + this.passwordSetting.passwordTips);
                    return false;
                }
                let _this = this;
                let postParams = {
                    mobile: this.user.mobile,
                    newPassword: this.password1,
                    sign: this.sign,
                }
                user_api.updatePassword(postParams).then(res => {
                    if (res.code == 200) {
                        this.$Toast.success("密码更新成功！");
                        setTimeout(() => {
                            _this.$router.replace("/");
                        }, 2000);
                    } else {
                        this.$Toast.fail("修改密码出错错误");
                    }
                })
            },
            Login() {
                this.$router.push({
                    path: "/login",
                    query: {}
                })
            },
            dev() {
                this.$toast("功能暂不可用")
            }
        },
    };
</script>